export default __webpack_public_path__ + "static/media/DSCN2295.2c1768ed.JPG";